import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Support = () => {
  const [copied, setCopied] = useState(false);
  const email = 'support.wingcue@gmail.com';

  const handleCopy = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const faqs = [
    {
      q: 'How does Wingcue analyze my screenshots?',
      a: 'Wingcue uses advanced AI to read the conversation context in your screenshot and generate tailored reply suggestions. Images are processed in real time and deleted within 24 hours.',
    },
    {
      q: 'Is my data kept private?',
      a: 'Yes. We do not sell your data or use your screenshots to train AI models. See our Privacy Policy for full details.',
    },
    {
      q: 'How do I cancel my subscription?',
      a: 'Open the App Store on your device → tap your profile → Subscriptions → Wingcue → Cancel. Changes take effect at the end of the billing period.',
    },
    {
      q: "The app isn't working. What should I do?",
      a: `Try force-quitting and reopening the app. If the issue persists, email us at ${email} with your device model and iOS version.`,
    },
  ];

  return (
    <div className="min-h-screen bg-black">
      <div className="border-b border-white/5">
        <div className="max-w-3xl mx-auto px-6 py-8 flex items-center justify-between">
          <Link to="/" className="text-white/30 hover:text-white transition-colors text-sm font-medium tracking-wide">
            ← Back
          </Link>
          <span className="text-xs text-white/20 tracking-widest uppercase font-medium">Wingcue</span>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-16 space-y-14">
        <div className="space-y-3">
          <h1 className="text-4xl font-black text-white tracking-tighter">Support</h1>
          <p className="text-[15px] text-white/40 leading-relaxed">
            We're here to help. Reach out anytime or browse the FAQs below.
          </p>
        </div>

        <div className="rounded-2xl border border-white/8 bg-white/[0.03] p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div className="space-y-1">
            <p className="text-xs text-white/30 tracking-widest uppercase font-semibold">Email Us</p>
            <p className="text-xl font-bold text-white tracking-tight">{email}</p>
            <p className="text-sm text-white/35">We typically respond within 24 hours.</p>
          </div>
          <div className="flex gap-3">
            <a
              href={`mailto:${email}`}
              className="px-5 py-2.5 rounded-xl bg-[#E94E34] text-white text-sm font-semibold hover:bg-[#d44430] transition-colors"
            >
              Send Email
            </a>
            <button
              onClick={handleCopy}
              className="px-5 py-2.5 rounded-xl bg-white/5 border border-white/10 text-white/60 text-sm font-semibold hover:bg-white/10 transition-colors"
            >
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>
        </div>

        <div className="space-y-6">
          <h2 className="text-lg font-bold text-white tracking-tight">Frequently Asked Questions</h2>
          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <div key={i} className="rounded-xl border border-white/8 bg-white/[0.02] p-6 space-y-2">
                <p className="text-sm font-semibold text-white">{faq.q}</p>
                <p className="text-[14px] text-white/45 leading-relaxed">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="border-l-2 border-[#E94E34]/40 pl-5">
          <p className="text-[15px] text-white/50 leading-relaxed">
            Still need help?{' '}
            <a
              href={`mailto:${email}`}
              className="text-white/70 hover:text-white underline underline-offset-2 transition-colors"
            >
              Email {email}
            </a>{' '}
            and we'll get back to you as soon as possible.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Support;